import { READY_CHANGE_STATE } from '../actions/carMapStateActions'

const initialState = {}

const carMapStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case READY_CHANGE_STATE: {
      var nextState = Object.assign({}, state)

      nextState[action.name] = action.value

      return Object.assign(
        {},
        state,
        nextState
      )
    }
    default:
      return state
  }
}

export default carMapStateReducer
